module.exports = __webpack_public_path__ + "static/media/first-meeting.c10a33f7.svg";